export default {
    updateCookies(responseHeader) {
        this.updateBearerToken(responseHeader)
        this.updateSystemCookies();
    },

    updateBearerToken(responseHeader) {
        window.$cookies.set("token", 'Bearer ' + responseHeader['authorization']);
    },

    updateSystemCookies() {
        let userRights = window.$cookies.get("userRights");
        let currentUser = window.$cookies.get("currentUser");
        let highestUserRoleHierarchy = window.$cookies.get("highestUserRoleHierarchy");

        window.$cookies.set("userRights", userRights);
        window.$cookies.set("currentUser", currentUser);
        window.$cookies.set("highestUserRoleHierarchy", highestUserRoleHierarchy);
    }
}



// WEBPACK FOOTER //
// ./src/managers/cookiemanager.js